
export default function AddUsersButtonDirective() {
    'ngInject';
    return {
        template: require('./add-users-button.html'),
        restrict: 'E',
        scope: {
            disabled: '=',
        }
    };
}
